<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <div class="playBtn"
       @click="setLoading()">
    <transition
      enterActiveClass="animated zoomIn"
      leaveActiveClass="animated zoomOut"
      mode="out-in">
      <template v-if="!loading || !isLoadingApi">
        <svg :width="`${size}px`" :height="`${size}px`" viewBox="0 0 44 44" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Play</title>
          <circle stroke-opacity="0.5" stroke="#FFFFFF" fill-opacity="0.6" fill="#000000"
                  stroke-width="2" cx="22" cy="22" r="21" id="svg_2"/>
          <path
            d="m21.0641,23.19584l2.12119,-2.11999l12.72349,12.73069l-2.12119,2.11999l-12.72349,-12.73069zm-4.96802,-4.97195l2.1213,-2.1213l3.5348,3.5348l-2.1213,2.1213l-3.5348,-3.5348zm9.90392,-6.22389l4,1l-4,1l-1,4l-1,-4l-4,-1l4,-1l1,-4l1,4zm-12,2l-1,4l-1,-4l-4,-1l4,-1l1,-4l1,4l4,1l-4,1zm1,7l1,4l4,1l-4,1l-1,4l-1,-4l-4,-1l4,-1l1,-4z"
            id="Combined-Shape" fill="#FFFFFF" fill-rule="nonzero"/>
        </svg>
      </template>
      <template v-if="loading && isLoadingApi">
        <fade-loader
          :color="colors.mainActionColor"
          :height="'12px'"
          :width="'6px'"
           style="top: -8px;"
        />
      </template>
    </transition>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';

export default {
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    isLoadingApi(val) {
      if (this.loading) {
        if (val === false) {
          this.loading = false;
        }
      }
    },
  },
  name: 'highlights-btn',
  components: {
    FadeLoader,
  },
  props: {
    size: {
      required: false,
      default: '44',
    },
  },
  methods: {
    setLoading() {
      this.loading = true;
    },
  },
  computed: {
    ...mapState(['isLoadingApi', 'colors']),
  },
};
</script>
